//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export enum UniversalSearchSortKey {
  Comments = 'Comments',
  CompletionRate = 'CompletionRate',
  CTR = 'CTR',
  EngagementRate = 'EngagementRate',
  EngagementRateWithReach = 'EngagementRateWithReach',
  Exits = 'Exits',
  Impressions = 'Impressions',
  Likes = 'Likes',
  Reach = 'Reach',
  Replies = 'Replies',
  Revenue = 'Revenue',
  Saves = 'Saves',
  Shares = 'Shares',
  SimilarityToActedOnScore = 'SimilarityToActedOnScore',
  PostedTimestamp = 'PostedTimestamp',
  VideoViews = 'VideoViews',
  Views = 'Views',
  Visits = 'Visits',
  VisualScore = 'VisualScore',
}
